module.exports = __webpack_public_path__ + "img/hu.844eeb9e.svg";